import { createSlice } from "@reduxjs/toolkit";

/**
 * The initial state for the project slice.
 *
 * @typedef {Object} ProjectState
 * @property {Array<string>} topOptionsConcepts - An array of concept options.
 * @property {number} totalDocCount - The total document count.
 * @property {boolean} sentimentDisabled - Indicates if sentiment analysis is disabled.
 */

const projectSlice = createSlice({
    name: "project",
    initialState: {
        topOptionsConcepts: [],
        totalDocCount: 0,
        sentimentDisabled: false,
    },
    reducers: {
        setTopOptionsConcepts: (state, action) => {
            state.topOptionsConcepts = action.payload;
        },
        setTotalDocCount: (state, action) => {
            state.totalDocCount = action.payload;
        },
        setSentimentDisabled: (state, action) => {
            state.sentimentDisabled = action.payload;
        },
    },
});

export const {
    setTopOptionsConcepts,
    setTotalDocCount,
    setSentimentDisabled,
} = projectSlice.actions;

export default projectSlice.reducer;
